import { type ResultOf } from '@graphql-typed-document-node/core'

import { graphql } from '~/gql'

import { QuestionOp } from '../modelOperators'

const questionFragment = graphql(`
  fragment FigureInfoHelpers_ToQuestionTexts_Question on Question {
    question_id
    question_text
  }
`)
type Question = ResultOf<typeof questionFragment>

/**
 * 設問の ID の配列から、設問のテキストの配列を作成します。
 *
 * @param questionIds - 設問の ID の配列。
 * @param questions - 設問の配列。
 * @returns 設問のテキストの配列。
 */
export function toQuestionTexts(questionIds: string[], questions: Question[]) {
  return questions
    .filter((question) => questionIds.includes(question.question_id))
    .map(QuestionOp.toText)
}
